export const quizzes = {
  in: [
    {
      id: 1,
      type: 'multiple_choice',
      quiz: 'Transversal kompetensiya nimani anglatadi?',
      options: ["Tor doiradagi bilim va ko‘nikmalar", "Turli sohalarga tatbiq etiladigan umumiy kompetensiyalar", "Faqat pedagogik kompetensiya", "Yangi texnologiyalarni o‘rganish"],
      answer: "Turli sohalarga tatbiq etiladigan umumiy kompetensiyalar",
    },
    {
      id: 2,
      type: 'multiple_choice',
      quiz: 'Transversal kompetensiyalarga misol bo‘la oladigan jihatlar qaysilar?',
      options: ["Muammolarni hal qilish, muloqot, kreativlik", "Faqat akademik bilimlar", "Texnik ko‘nikmalar", "Nazariy tushunchalar"],
      answer: "Muammolarni hal qilish, muloqot, kreativlik",
    },
    {
      id: 3,
      type: 'multiple_choice',
      quiz: 'Transversal kompetensiyalar kimlar uchun muhim?',
      options: ["Faqat o‘qituvchilar uchun", "Hamma kasblar uchun", "Faqat talabalarga kerak", "Faqat menejerlar uchun"],
      answer: "Hamma kasblar uchun",
    },
    {
      id: 4,
      type: 'multiple_choice',
      quiz: 'Kreativ fikrlash transversal kompetensiyaga kiradimi?',
      options: ["Ha", "Yo‘q", "Faqat dizaynerlar uchun muhim", "Barcha pedagogik jarayonlarda ahamiyatsiz"],
      answer: "Ha",
    },
    {
      id: 5,
      type: 'multiple_choice',
      quiz: 'Tarbiyachilarning transversal kompetensiyalari qanday rivojlantiriladi?',
      options: ["Interfaol metodlardan foydalanish", "Faqat nazariy bilimlarni o‘rganish", "Bolalar bilan kamroq muloqot qilish", "Shaxsiy rivojlanish bilan bog‘liq emas"],
      answer: "Interfaol metodlardan foydalanish",
    },
    {
      id: 6,
      type: 'multiple_choice',
      quiz: 'Transversal kompetensiyalarning asosiy xususiyati nima?',
      options: ["Ular ko‘p sohalarga tatbiq etiladi", "Faqat texnik bilimlar bilan bog‘liq", "Tor doiradagi mutaxassislik bo‘yicha", "Faqat nazariy ahamiyatga ega"],
      answer: "Ular ko‘p sohalarga tatbiq etiladi",
    },
    {
      id: 7,
      type: 'multiple_choice',
      quiz: 'Tanqidiy fikrlash nima?',
      options: ["Har qanday axborotni tahlil qilish va baholash qobiliyati", "Faqat tanqid qilish ko‘nikmasi", "Shunchaki xotirada saqlash jarayoni", "Faqat ijobiy fikrlash"],
      answer: "Har qanday axborotni tahlil qilish va baholash qobiliyati",
    },
    {
      id: 8,
      type: 'multiple_choice',
      quiz: 'Transversal kompetensiyalarni o‘rgatishda qanday metod samarali?',
      options: ["Muammoli ta’lim", "Talabalarga mustaqil o‘rganishni topshirish", "Bir yo‘nalishga asoslangan o‘qitish", "Yodlashga asoslangan uslub"],
      answer: "Muammoli ta’lim",
    },
    {
      id: 9,
      type: 'multiple_choice',
      quiz: 'Tarbiyachining kommunikativ kompetensiyasi nimani anglatadi?',
      options: ["Samarali muloqot va ta’sirchan gapirish qobiliyati", "Faqat yozma aloqa", "Faqat dars jarayonini boshqarish", "Til bilish darajasi"],
      answer: "Samarali muloqot va ta’sirchan gapirish qobiliyati",
    },
    {
      id: 10,
      type: 'multiple_choice',
      quiz: 'Tarbiyachilarning yetakchilik qobiliyati qanday transversal kompetensiyaga kiradi?',
      options: ["Menejment va liderlik", "Texnik bilimlar", "Matematik kompetensiya", "San’at yo‘nalishi"],
      answer: "Menejment va liderlik",
    },
    {
      id: 11,
      type: 'multiple_choice',
      quiz: 'Metodik kompetensiya nima?',
      options: ["Shaxsiy bilimlarni mustahkamlash", "O‘quv jarayonini rejalashtirish va o‘qitish metodlarini bilish", "Faqat amaliy ko‘nikmalarni egallash", "Faqat nazariy bilimlarni o‘rganish"],
      answer: "O‘quv jarayonini rejalashtirish va o‘qitish metodlarini bilish",
    },
    {
      id: 12,
      type: 'multiple_choice',
      quiz: 'O‘qitish metodlarining qaysi biri interfaol hisoblanadi?',
      options: ["Bahs-munozara va rolli o‘yinlar", "Tez-tez yozma ishlar", "Faqat mustaqil ishlar", "Tadqiqot ishlari"],
      answer: "Bahs-munozara va rolli o‘yinlar",
    },
    {
      id: 13,
      type: 'multiple_choice',
      quiz: 'Maktabgacha ta’limda pedagogik texnologiyalar deganda nima tushuniladi?',
      options: ["Tarbiyachining o‘zi uchun tayyorlangan o‘quv materiallari", "Ta’lim jarayonini innovatsion yondashuv bilan rivojlantirish", "Yangi metodlar va usullarni o‘rganish", "Faqat eski metodlar asosida o‘qitish"],
      answer: "Ta’lim jarayonini innovatsion yondashuv bilan rivojlantirish",
    },
    {
      id: 14,
      type: 'multiple_choice',
      quiz: 'Tarbiyachi ta’lim jarayonida pedagogik metodlardan qanday foydalanish kerak?',
      options: ["Doimiy va o‘zgarmas metodlardan foydalanish", "Bolalarning ehtiyojlari va qobiliyatlariga mos metodlarni tanlash", "Faqat tarbiyachi tomonidan belgilangan metodlardan foydalanish", "Metodlarni o‘zgartirmaslik"],
      answer: "Bolalarning ehtiyojlari va qobiliyatlariga mos metodlarni tanlash",
    },
    {
      id: 15,
      type: 'multiple_choice',
      quiz: 'Tarbiyachi pedagogik faoliyatda mustaqil fikrlashni qanday rivojlantiriladi?',
      options: ["Bolalarga doimiy topshiriqlar berish", "Bolalarni mustaqil ishlar va loyiha ishlari orqali rivojlantirish", "Faol o‘qitishdan chetlashish", "Faqat nazariy bilimlar berish va mashg’ulotlar o’tish"],
      answer: "Bolalarni mustaqil ishlar va loyiha ishlari orqali rivojlantirish",
    },
    {
      id: 16,
      type: 'multiple_choice',
      quiz: 'O‘qitish metodining asosiy printsiplari nimalardan iborat?',
      options: ["Faoliyat, individual yondashuv, bolalarni rag‘batlantirish", "Faoliyat, nazariy bilimlar, passiv yondashuv", "Mashg‘ulotlarni qisqartirish, ma’lumotlarni tez-tez taqdim etish", "O‘quvchilarni doimiy kuzatib borish"],
      answer: "Faoliyat, individual yondashuv, bolalarni rag‘batlantirish",
    },
    {
      id: 17,
      type: 'multiple_choice',
      quiz: 'Metodik kompetensiya qanday rivojlanadi?',
      options: ["Amaliyot va tajriba orqali", "Yodlash va nazariy bilimlarni oshirish orqali", "Faqat nazariy ta’lim bilan", "O‘quvchi bilan bog‘liq bo‘lmagan faoliyat orqali"],
      answer: "Amaliyot va tajriba orqali",
    },
    {
      id: 18,
      type: 'multiple_choice',
      quiz: 'Tarbiyachining kommunikativ kompetensiyasi nimani anglatadi?',
      options: ["Bolalar bilan faqat nazariy muloqot qilish", "Samarali muloqot va ta’sirchan gapirish qobiliyati", "Faqat tarbiyachining shaxsiy yondashuvi", "Tashqi ko‘rinish va tashkiliy faoliyat"],
      answer: "Samarali muloqot va ta’sirchan gapirish qobiliyati",
    },
    {
      id: 19,
      type: 'multiple_choice',
      quiz: 'Tarbiyachining metodik kompetensiyasining samarali rivojlanishi uchun qanday usullar samarali?',
      options: ["Yangi metodlarni o‘rganish va amaliyotda qo‘llash", "Faqat joriy metodlarni qo‘llash", "Yangi metodlardan foydalanmaslik", "Bolalarni faqat nazariy bilimlar bilan ta’minlash"],
      answer: "Yangi metodlarni o‘rganish va amaliyotda qo‘llash",
    },
    {
      id: 20,
      type: 'multiple_choice',
      quiz: 'Metodik kompetensiyani rivojlantirishda qanday pedagogik texnologiyalar qo‘llaniladi?',
      options: ["Bahs-munozaralar, amaliy mashg‘ulotlar", "Faqat yozma ishlar", "Qat’iy nazorat va sinovlar", "Tez-tez mashg’ulotlar o’tish va bolalarga tushuntirish"],
      answer: "Bahs-munozaralar, amaliy mashg‘ulotlar",
    },
    {
      id: 21,
      type: 'multiple_choice',
      quiz: 'Ta’limda metodlarning qaysi turi samarali hisoblanadi?',
      options: ["Faqat amaliy metodlar", "Bolalarning qiziqishlariga mos keladigan va samarali metodlar", "Qat’iy nazariy yondashuv", "Mashg’ulotdan  tashqari metodlar"],
      answer: "Bolalarning qiziqishlariga mos keladigan va samarali metodlar",
    },
    {
      id: 22,
      type: 'multiple_choice',
      quiz: 'Tarbiyachilarni metodik kompetensiyalarini rivojlantirishda asosiy ahamiyatga ega bo‘lgan omil nima?',
      options: ["Amaliyotda o‘qitish", "Faqat nazariy bilimlarni o‘rganish", "Keng pedagogik yondashuvni qo‘llash", "Shaxsiy ravishda o’z ustida ishlash"],
      answer: "Keng pedagogik yondashuvni qo‘llash",
    },
    {
      id: 23,
      type: 'multiple_choice',
      quiz: 'Tarbiyachilarda metodik kompetensiyalarni rivojlantirish uchun qanday usullar qo‘llaniladi?',
      options: ["Muammoli ta’lim, bolalarning faol ishtiroki", "Faqat amaliy mashg‘ulotlar", "Yalpi tushuntirish va yodlash", "Passiv o‘qitish"],
      answer: "Muammoli ta’lim, bolalarning faol ishtiroki",
    },
    {
      id: 24,
      type: 'multiple_choice',
      quiz: 'Metodik kompetensiyaning asosiy maqsadi nima?',
      options: ["Bolalarning bilim darajasini baholash", "Tarbiyachining pedagogik faoliyatini rivojlantirish", "Faqat bilimlarni o’zlashtirish", "Faoliyatni faqat nazariy shaklda o‘rganish"],
      answer: "Tarbiyachining pedagogik faoliyatini rivojlantirish",
    },
    {
      id: 25,
      type: 'multiple_choice',
      quiz: 'Pedagogik metodlarni tanlashda qanday omillar e’tiborga olinadi?',
      options: ["Bolalarning qobiliyatlari, qiziqishlari va ehtiyojlari", "Faqat tarbiyachining bolalarga nisbatan shaxsiy yondashuvi", "Bolalarning yoshi", "Faqat guruhdagi bolalarning miqdori"],
      answer: "Bolalarning qobiliyatlari, qiziqishlari va ehtiyojlari",
    },
  ],
  finish: [
    {
      id: 1,
      type: 'multiple_choice',
      quiz: 'Transversal kompetensiyalarning rivojlanishi natijasida tarbiyachida nima shakllanadi?',
      options: ["Reproduktiv fikrlash va kreativlik", "Passiv bolalarga moslashish va kreativlik", "Moslashuvchanlik, kreativlik va jamoaviy ishlash qobiliyati", "Nazoratga qaramlik"],
      answer: "Moslashuvchanlik, kreativlik va jamoaviy ishlash qobiliyati",
    },
    {
      id: 2,
      type: 'multiple_choice',
      quiz: 'Quyidagilardan qaysi biri transversal kompetensiyaning asosiy belgisi hisoblanadi?',
      options: ["Kasbiy bilimlar darajasi", "Qat’iy intizomga bo‘lgan munosabat", "Har qanday kontekstda qo‘llanilishi mumkin bo‘lgan ko‘nikma", "O‘z mutaxassisligiga doir amaliy ko‘nikma"],
      answer: "Har qanday kontekstda qo‘llanilishi mumkin bo‘lgan ko‘nikma",
    },
    {
      id: 3,
      type: 'multiple_choice',
      quiz: 'Transversal kompetensiyani rivojlantirishda eng samarali yondashuv qaysi?',
      options: ["Reproduktiv yondashuv", "Faoliyatli yondashuv", "Kompetensiyaviy yondashuv", "Fanni chuqur bilish"],
      answer: "Kompetensiyaviy yondashuv",
    },
    {
      id: 4,
      type: 'multiple_choice',
      quiz: 'Quyidagi vaziyatni baholang: Tarbiyachi interfaol mashg’ulot metodini guruhda qo‘llay oldi, ammo guruhni boshqara olmadi. Bu nimalarning yetishmasligidan darak?',
      options: ["Texnologik savodxonlik", "Ijtimoiy-emotsional kompetensiya", "Metodik bilim yetishmasligidan", "Rivojlangan analitik tafakkur"],
      answer: "Ijtimoiy-emotsional kompetensiya",
    },
    {
      id: 5,
      type: 'multiple_choice',
      quiz: 'Transversal kompetensiyalar asosan qanday yo‘nalishlarda namoyon bo‘ladi?',
      options: ["Maxsus bilimlar, texnik ko‘nikmalar", "Muloqot, tanqidiy fikrlash, muammoli vaziyatda qaror qabul qilish", "Fanlararo bog‘liqliklar va tarbiyachining bilimi", "Aniq kompetensiyalarda namoyon bo’ladi"],
      answer: "Muloqot, tanqidiy fikrlash, muammoli vaziyatda qaror qabul qilish",
    },
    {
      id: 6,
      type: 'multiple_choice',
      quiz: 'Bo’lajak tarbiyachilarda metodik kompetensiya qanday shakllanadi?',
      options: ["Metodik tavsiyalar olish orqali", "Ilmiy konferensiyada qatnashish orqali", "Real dars vaziyatlarini tahlil qilish va tajriba asosida", "Amaliy tajriba orqali"],
      answer: "Real dars vaziyatlarini tahlil qilish va tajriba asosida",
    },
    {
      id: 7,
      type: 'multiple_choice',
      quiz: 'Transversal kompetensiyalarning barqaror shakllanishi uchun nima kerak?',
      options: ["Qattiq nazorat va mustahkam bilim", "Darsga o’z vaqtida qatnashish", "Integratsiyalashgan, faoliyatga yo‘naltirilgan o‘qitish", "Reproduktiv metodlar"],
      answer: "Integratsiyalashgan, faoliyatga yo‘naltirilgan o‘qitish",
    },
    {
      id: 8,
      type: 'multiple_choice',
      quiz: 'Bolalarda tanqidiy fikrlashni rivojlantirish uchun qanday topshiriqlar samarali?',
      options: ["Eslab qolishga asoslangan rasmlar berish", "Muammoli savollar va tahliliy vazifalar berish", "Yodlashga asoslangan vazifalar berish", "Ko‘rgazmali qurollardan foydalanish"],
      answer: "Muammoli savollar va tahliliy vazifalar berish",
    },
    {
      id: 9,
      type: 'multiple_choice',
      quiz: 'Tarbiyachi mashg’ulot davomida bolaning ehtiyojiga qarab metodni moslash bu –',
      options: ["Moslashuvchanlik ko‘nikmasi", "Dastlabki reja", "O‘quv dasturining bir qismi", "Transversal kompetensiya"],
      answer: "Moslashuvchanlik ko‘nikmasi",
    },
    {
      id: 10,
      type: 'multiple_choice',
      quiz: 'Maktabgacha ta’lim tashkilotida bolalarning transversal kompetensiyalarni baholashda eng muhim yondashuv –',
      options: ["Natijani raqamlashtirish", "Faoliyatni tahlil qilish va refleksiya", "Ota-onalardan so’rovnoma o’tkazish", "Bolalarni savol-javob qilish"],
      answer: "Faoliyatni tahlil qilish va refleksiya",
    },
    {
      id: 11,
      type: 'multiple_choice',
      quiz: 'Transversal kompetensiyalar qanday yo‘nalishlar orqali rivojlanadi?',
      options: ["Mustaqil izlanish, hamkorlik, ijodiy yondashuv", "Metodik yondashuv, kasbiy izlanish", "o’z ustida ishlash va kasbiy rivojlanish", "Metodlarni qo’llash va ulardan faoydalanish"],
      answer: "Mustaqil izlanish, hamkorlik, ijodiy yondashuv",
    },
    {
      id: 12,
      type: 'multiple_choice',
      quiz: 'Tarbiyachi  mashg’ulotni o‘tkazdi, lekin bolalar tushunmadi. Bu qanday muammo?',
      options: ["Texnik yetishmovchilik", "Metodik yondashuvda xatolik", "Material murakkabligi", "Bolalarning e’tiborsizligi"],
      answer: "Metodik yondashuvda xatolik",
    },
    {
      id: 13,
      type: 'multiple_choice',
      quiz: 'Talabaning o‘z pedagogik faoliyatini tahlil qilishi qanday ko‘nikmani ifodalaydi?',
      options: ["Reflektivlik", "Integrativlik", "Kompetensiyaviy yondashuv", "Tahlil va nazorat"],
      answer: "Reflektivlik",
    },
    {
      id: 14,
      type: 'multiple_choice',
      quiz: 'Tarbiyachi guruhdagi muammoni anglab, yangicha usul qo‘lladi. Bu –',
      options: ["Muammoga innovatsion yondashuv", "samarali interfaol yondashuv", "Muammoni hal etish", "Reproduktiv metod"],
      answer: "Muammoga innovatsion yondashuv",
    },
    {
      id: 15,
      type: 'multiple_choice',
      quiz: 'Quyidagi usullardan qaysi biri talabani fikrlashga, tanqidiy baholashga va muammoni hal qilishga undaydi?',
      options: ["Reproduktiv testlar", "'Blits' so‘rovlari", "Keys (case-study) usuli", "Qisqa yozma savollar"],
      answer: "Keys (case-study) usuli",
    },
    {
      id: 16,
      type: 'multiple_choice',
      quiz: 'O‘qituvchi darsda muammoli savol qo‘ydi: “Nega bolalar faol bo‘lmayapti?” Talabalar bunga sabab va yechim taklif qildilar. Bu qanday ko‘nikma shakllantiradi?',
      options: ["Tahliliy ko‘nikma", "Tanqidiy fikrlash va tahliliy yondashuv", "Reproduktiv yondashuv va ta’limiy", "Ta’limiy ko‘rsatma berish va amalga oshirish"],
      answer: "Tanqidiy fikrlash va tahliliy yondashuv",
    },
    {
      id: 17,
      type: 'multiple_choice',
      quiz: 'Tarbiyachi mashg’ulotdan keyin: “Men mashg’ulotning kirish qismini juda uzun qilgan ekanman, individual yondashuvga vaqtim yetmadi” – deb o’yladi. Bu qanday kompetensiya shakli?',
      options: ["Diagnostik", "Refleksiv", "Kommunikativ", "Nazariy"],
      answer: "Refleksiv",
    },
    {
      id: 18,
      type: 'multiple_choice',
      quiz: 'Tarbiyachilarni metodik kompetensiyalarini rivojlantirishda asosiy ahamiyatga ega bo‘lgan omil nima?',
      options: ["Amaliyotda o‘qitish", "Faqat nazariy bilimlarni o‘rganish", "Keng pedagogik yondashuvni qo‘llash", "Shaxsiy ravishda o’z ustida ishlash"],
      answer: "Keng pedagogik yondashuvni qo‘llash",
    },
    {
      id: 19,
      type: 'multiple_choice',
      quiz: 'Pedagogik metodlarni tanlashda qanday omillar e’tiborga olinadi?',
      options: ["Bolalarning qobiliyatlari, qiziqishlari va ehtiyojlari", "Faqat tarbiyachining bolalarga nisbatan shaxsiy yondashuvi", "Bolalarning Yoshi va temperamenti", "Faqat guruhdagi bolalarning miqdori"],
      answer: "Bolalarning qobiliyatlari, qiziqishlari va ehtiyojlari",
    },
    {
      id: 20,
      type: 'multiple_choice',
      quiz: 'Tarbiyachi muammolarni hal qilishda pedagogik texnologiyalar qanday yordam beradi?',
      options: ["Bolalarni bilimli qiladi", "Ta’lim jarayonini interaktiv va samarali qiladi", "Bolalarni faol va o’zlashtirishga yordam beradi", "Faqat ma’lumotlarni o‘rgatadi"],
      answer: "Ta’lim jarayonini interaktiv va samarali qiladi",
    }
  ],
  iq: [
    {
      id: 1,
      type: 'multiple_choice',
      quiz: 'Agar bugun seshanba bo‘lsa, 25 kundan keyin haftaning qaysi kuni bo‘ladi?',
      options: ["Juma", "Shanba", "Dushanba", "Chorshanba"],
      answer: "Shanba",
    },
    {
      id: 2,
      type: 'multiple_choice',
      quiz: 'Agar barcha olma mevalar bo‘lsa, lekin barcha mevalar olma bo‘lmasa, quyidagilardan qaysi biri to‘g‘ri?',
      options: ["Har qanday meva olma emas", "Har qanday olma meva", "Olma meva emas", "Olma va meva bir xil tushuncha"],
      answer: "Har qanday olma meva",
    },
    {
      id: 3,
      type: 'multiple_choice',
      quiz: '3, 6, 12, 24, 48, ?. Ketma-ketlikdagi keyingi sonni toping.',
      options: ["96", "64", "72", "128"],
      answer: "96",
    },
    {
      id: 4,
      type: 'multiple_choice',
      quiz: '5 ta odam 5 ta stulga 5 xil usulda o‘tirishi mumkin. 6 ta odam 6 ta stulga necha xil usulda o‘tirishi mumkin?',
      options: ["6", "720", "120", "30"],
      answer: "720",
    },
    {
      id: 5,
      type: 'multiple_choice',
      quiz: 'Qaysi so‘z mantiqan ortiqcha? jurnal, gazeta, kitob, risola',
      options: ["jurnal", "gazeta", "kitob", "risola"],
      answer: "kitob",
    },
    {
      id: 6,
      type: 'multiple_choice',
      quiz: '20 ta bola bir guruh bo‘lib turibdi. Agar har biri ikkitadan do‘st topishi kerak bo‘lsa, eng kamida nechta do‘stlik aloqasi bo‘lishi kerak?',
      options: ["20 ta", "10 ta", "40 ta", "22 ta"],
      answer: "20 ta",
    },
    {
      id: 7,
      type: 'multiple_choice',
      quiz: '8-16-32-64-?, ketma-ketlikdagi keyingi sonni toping.',
      options: ["128", "256", "4", "32"],
      answer: "128",
    },
    {
      id: 8,
      type: 'multiple_choice',
      quiz: 'O‘qituvchi 40 ta testni 5 daqiqada tekshirsa, 200 ta testni necha daqiqada tekshiradi?',
      options: ["20 daqiqa", "40 daqiqa", "200 daqiqa", "25 daqiqa"],
      answer: "25 daqiqa",
    },
    {
      id: 9,
      type: 'multiple_choice',
      quiz: 'Bir uyda 6 ta xona bor. Har bir xonaga 2 ta eshik kerak. Jami necha eshik bo‘lishi mumkin?',
      options: ["6 ta eshik", "10 ta eshik", "12 ta eshik", "6 ta eshik"],
      answer: "12 ta eshik",
    },
    {
      id: 10,
      type: 'multiple_choice',
      quiz: '9, 18, 36, 72, ?, 288. Bo‘sh joyga qaysi son mos keladi?',
      options: ["144", "108", "216", "135"],
      answer: "144",
    }
  ]
};

export const psychologyquestions = {
  basic: [
    {
      id: 1,
      question: "Siz uchun bolalar bilan ishlash qanday tajriba?",
      options: [
        { text: "Juda qiziqarli, bolalar bilan ishlash menga zavq bag‘ishlaydi", score: 3 },
        { text: "O‘rtacha, ba’zida qiziqarli, ba’zida qiyin", score: 2 },
        { text: "Menga unchalik yoqmaydi, lekin majburiyat sifatida bajaraman", score: 1 }
      ]
    },
    {
      id: 2,
      question: "Agar bola noto‘g‘ri xatti-harakat qilsa, qanday yo‘l tutasiz?",
      options: [
        { text: "Undan nega bunday qilganini so‘rayman va tushuntirish beraman", score: 3 },
        { text: "Jazo berib, boshqa bunday qilmasligini ta’kidlayman", score: 2 },
        { text: "E’tibor bermayman yoki boshqa bolalar oldida gap qaytarmasligini ta’kidlayman", score: 1 }
      ]
    },
    {
      id: 3,
      question: "Stressli vaziyatlarda qanday yo‘l tutasiz?",
      options: [
        { text: "Tinchlanish usullaridan foydalanaman va vaziyatni tahlil qilaman", score: 3 },
        { text: "Shoshilinch ravishda muammo yechimini izlayman", score: 2 },
        { text: "Asabiylashib ketaman va his-tuyg‘ularimni boshqara olmayman", score: 1 }
      ]
    },
    {
      id: 4,
      question: "Jamoaviy ishlashga qanday munosabatdasiz?",
      options: [
        { text: "Jamoa bilan ishlashni yaxshi ko‘raman, hamkorlik muhim", score: 3 },
        { text: "O‘zim ishlashni afzal ko‘raman, lekin jamoada ham ishlay olaman", score: 2 },
        { text: "Jamoada ishlash menga qiyin, mustaqil harakat qilganim yaxshi", score: 1 }
      ]
    },
    {
      id: 5,
      question: "Dars davomida bolalar diqqatini qanday ushlab turasiz?",
      options: [
        { text: "Interaktiv usullar va qiziqarli mashg‘ulotlardan foydalanaman", score: 3 },
        { text: "Ularning e’tiborini qayta yo‘naltirishga harakat qilaman", score: 2 },
        { text: "Kattalar nazorat qilishi kerak, bolalar o‘zlarini tutishi lozim", score: 1 }
      ]
    },
    {
      id: 6,
      question: "Qanday pedagogik texnologiyalardan foydalanishni afzal bilasiz?",
      options: [
        { text: "O‘yin texnologiyalari, interaktiv metodlar", score: 3 },
        { text: "An’anaviy usullar bilan zamonaviy yondashuvlarni aralashtirib qo‘llayman", score: 2 },
        { text: "An’anaviy usullarni afzal bilaman", score: 1 }
      ]
    },
    {
      id: 7,
      question: "Bola o‘z muammosi haqida gapirmasa, qanday yo‘l tutasiz?",
      options: [
        { text: "U bilan alohida suhbat o‘tkazaman, ishonchli muhit yarataman", score: 3 },
        { text: "Kutaman, balki o‘zi gapirib berar", score: 2 },
        { text: "Uning muammolariga aralashmayman", score: 1 }
      ]
    },
    {
      id: 8,
      question: "Qanday bolalarni tarbiyalash qiyin deb hisoblaysiz?",
      options: [
        { text: "Har bir bola o‘ziga xos, muammo ham o‘sish jarayonining bir qismi", score: 3 },
        { text: "O‘ta shovqinli va diqqatini jamlay olmaydigan bolalar", score: 2 },
        { text: "Intizomga bo‘ysunmaydigan bolalar", score: 1 }
      ]
    },
    {
      id: 9,
      question: "Bolalar bilan ishlashda qanday yondashuvni afzal ko‘rasiz?",
      options: [
        { text: "Har bir bolaga individual yondashaman", score: 3 },
        { text: "Guruh bilan ishlashga ko‘proq e’tibor qarataman", score: 2 },
        { text: "Qoidalarga qat’iy amal qilishni talab qilaman", score: 1 }
      ]
    },
    {
      id: 10,
      question: "Maktabgacha ta’lim sohasida innovatsiyalarni qanchalik qiziqib o‘rganasiz?",
      options: [
        { text: "Yangi metodlarni doimiy o‘rganib, darslarda qo‘llayman", score: 3 },
        { text: "Qiziqaman, lekin faqat zarur hollarda qo‘llayman", score: 2 },
        { text: "An’anaviy usullardan foydalanaman, innovatsiyalarga unchalik ishonmayman", score: 1 }
      ]
    }
  ],
  educator: [
    {
      id: 1,
      question: "Bolalar bilan ishlash sizga qanchalik yoqadi?",
      options: [
        { text: "Juda yoqadi, bu mening kasbimga bo‘lgan ishtiyoqim", score: 3 },
        { text: "Yoqqaniga yoqadi, lekin ba’zan charchatadi", score: 2 },
        { text: "Yo‘q, men boshqa kasbni tanlagan bo‘lishim kerak edi", score: 1 }
      ]
    },
    {
      id: 2,
      question: "Bolalar bilan ishlashda eng muhim sifat qaysi?",
      options: [
        { text: "Mehribonlik va sabr-toqat", score: 3 },
        { text: "Tashkilotchilik va intizomlilik", score: 2 },
        { text: "Qattiqqo‘llik va talabchanlik", score: 1 }
      ]
    },
    {
      id: 3,
      question: "Bolalar sizning darsingizga qiziqish bildirmayapsa, qanday yo‘l tutasiz?",
      options: [
        { text: "Interaktiv va qiziqarli metodlarni qo‘llayman", score: 3 },
        { text: "E’tibor qaratmagan bolalarni intizomga chaqiraman", score: 2 },
        { text: "Hech narsa qilmayman, ular o‘zlari qiziqishi kerak", score: 1 }
      ]
    },
    {
      id: 4,
      question: "Agar bola noto‘g‘ri harakat qilsa, qanday yo‘l tutasiz?",
      options: [
        { text: "U bilan suhbatlashaman, sababini tushuntiraman", score: 3 },
        { text: "Jazo beraman yoki ogohlantiraman", score: 2 },
        { text: "E’tibor bermayman", score: 1 }
      ]
    },
    {
      id: 5,
      question: "Stressli vaziyatlarda qanday yo‘l tutasiz?",
      options: [
        { text: "Xotirjamlik bilan muammoni hal qilishga harakat qilaman", score: 3 },
        { text: "Muammoni tezda yechishga harakat qilaman, lekin ba’zan asabiylashaman", score: 2 },
        { text: "Tez g‘azablanaman va o‘zimni yo‘qotib qo‘yaman", score: 1 }
      ]
    },
    {
      id: 6,
      question: "Jamoaviy ishlashga qanday qaraysiz?",
      options: [
        { text: "Jamoa bilan ishlashni yoqtiraman", score: 3 },
        { text: "Mustaqil ishlashni afzal ko‘raman, lekin jamoada ham ishlay olaman", score: 2 },
        { text: "Jamoaviy ish menga yoqmaydi", score: 1 }
      ]
    },
    {
      id: 7,
      question: "Tarbiyachi bolalar uchun qanday rol o‘ynashi kerak deb hisoblaysiz?",
      options: [
        { text: "Qo‘llab-quvvatlovchi va o‘rnak bo‘luvchi", score: 3 },
        { text: "Qoidalarni o‘rgatuvchi va nazorat qiluvchi", score: 2 },
        { text: "Faqat darsni o‘qitib, o‘z ishini bajaruvchi", score: 1 }
      ]
    },
    {
      id: 8,
      question: "Dars davomida bolalarning diqqatini ushlab turish uchun qanday yondashuvni qo‘llasiz?",
      options: [
        { text: "Faol metodlar va o‘yinlardan foydalanaman", score: 3 },
        { text: "Dars qiziq emas bo‘lsa ham, ulardan diqqat qilishni talab qilaman", score: 2 },
        { text: "Ularga erkinlik beraman, ular o‘zlari xohlagan ishni qilishsin", score: 1 }
      ]
    },
    {
      id: 9,
      question: "Qanday bolalar bilan ishlash qiyin deb hisoblaysiz?",
      options: [
        { text: "Har bir bola o‘ziga xos, muammo ham tarbiya jarayonining bir qismi", score: 3 },
        { text: "Juda shovqinli va diqqatini jamlay olmaydigan bolalar", score: 2 },
        { text: "Tartibsiz va qaysar bolalar", score: 1 }
      ]
    },
    {
      id: 10,
      question: "Tarbiyachi sifatida pedagogik texnologiyalardan qanchalik foydalanasiz?",
      options: [
        { text: "Har doim yangi metodlarni o‘rganib va qo‘llayman", score: 3 },
        { text: "Asosan an’anaviy usullarni ishlataman", score: 2 },
        { text: "Innovatsiyalarga qiziqmayman", score: 1 }
      ]
    },
    {
      id: 11,
      question: "O‘zingizni qanday yetakchi deb hisoblaysiz?",
      options: [
        { text: "Tashkilotchi, boshqalarni rag‘batlantira olaman", score: 3 },
        { text: "Mas’uliyatni bajara olaman, lekin ba’zan qo‘rqaman", score: 2 },
        { text: "Yetakchilik qilishni yoqtirmayman", score: 1 }
      ]
    },
    {
      id: 12,
      question: "Maktabgacha ta’limda eng muhim narsa nima?",
      options: [
        { text: "Bolalarning har tomonlama rivojlanishi", score: 3 },
        { text: "Intizom va tartib", score: 2 },
        { text: "O‘qituvchi obro‘si", score: 1 }
      ]
    },
    {
      id: 13,
      question: "Ota-onalar bilan ishlashga qanday qaraysiz?",
      options: [
        { text: "Hamkorlik qilish va maslahatlar berishni yoqtiraman", score: 3 },
        { text: "Ba’zan ota-onalar bilan ishlash qiyin bo‘lishi mumkin", score: 2 },
        { text: "Ota-onalar bilan ishlashni yoqtirmayman", score: 1 }
      ]
    },
    {
      id: 14,
      question: "Bolalar bilan ishlash davomida qanday muammolarga duch kelasiz?",
      options: [
        { text: "Har bir vaziyatni tajriba sifatida ko‘raman", score: 3 },
        { text: "Shovqin va tartibsizlik eng katta muammo deb hisoblayman", score: 2 },
        { text: "Bolalar bilan ishlash menga qiyinchilik tug‘diradi", score: 1 }
      ]
    },
    {
      id: 15,
      question: "Tarbiyachi sifatida eng katta maqsadingiz nima?",
      options: [
        { text: "Bolalarni har tomonlama rivojlantirish", score: 3 },
        { text: "Dars sifatini oshirish", score: 2 },
        { text: "Shunchaki o‘z ishimni bajarish", score: 1 }
      ]
    }
  ],
  activity: [
    {
      id: 1,
      question: "Dars davomida bolalarning faol ishtirokini ta’minlash uchun nima qilasiz?",
      options: [
        { text: "Qiziqarli topshiriqlar va o‘yinlardan foydalanaman", score: 3 },
        { text: "Oddiy savol-javob o‘tkazaman", score: 2 },
        { text: "Faqat darsni tushuntirib, ular eshitishini kutaman", score: 1 }
      ]
    },
    {
      id: 2,
      question: "Agar bola dars davomida e’tibor bermasa, qanday yo‘l tutasiz?",
      options: [
        { text: "Uning sabablarini bilishga harakat qilaman", score: 3 },
        { text: "Tanbeh beraman", score: 2 },
        { text: "E’tibor bermayman", score: 1 }
      ]
    },
    {
      id: 3,
      question: "O‘quvchilaringiz qanday uslub bilan bilim olishini aniqlashga harakat qilasizmi?",
      options: [
        { text: "Ha, har bir bolaning o‘ziga xos o‘rganish uslubini tushunishga harakat qilaman", score: 3 },
        { text: "Ba’zan, lekin doim ham bu muhim deb o‘ylamayman", score: 2 },
        { text: "Yo‘q, bu muhim emas", score: 1 }
      ]
    },
    {
      id: 4,
      question: "Bolalar o‘rtasida nizolar kelib chiqsa, qanday yo‘l tutasiz?",
      options: [
        { text: "Suhbat orqali muammoni hal qilishga harakat qilaman", score: 3 },
        { text: "Qoidalarni eslatib, qat’iy tartib o‘rnataman", score: 2 },
        { text: "E’tibor bermayman, ular o‘zlari hal qilishsin", score: 1 }
      ]
    },
    {
      id: 5,
      question: "Maktabgacha yoshdagi bolalar bilan ishlashga qanday munosabatdasiz?",
      options: [
        { text: "Men bu yoshdagi bolalar bilan ishlashni juda yoqtiraman", score: 3 },
        { text: "Ba’zan qiyin bo‘lsa-da, ishlashga harakat qilaman", score: 2 },
        { text: "Men kattaroq yoshdagilar bilan ishlashni afzal ko‘raman", score: 1 }
      ]
    },
    {
      id: 6,
      question: "Ota-onalar bilan qanday ishlashni afzal ko‘rasiz?",
      options: [
        { text: "Ota-onalar bilan muntazam suhbatlashib, maslahat beraman", score: 3 },
        { text: "Faqat kerak bo‘lsa, aloqa qilaman", score: 2 },
        { text: "Ota-onalar bilan ishlashga unchalik qiziqmayman", score: 1 }
      ]
    },
    {
      id: 7,
      question: "Pedagogik faoliyatda yangi metodlarni sinash taklif qilinsa, qanday javob berasiz?",
      options: [
        { text: "Men yangi metodlarni sinab ko‘rishga tayyorman", score: 3 },
        { text: "Agar foydali bo‘lsa, sinab ko‘raman", score: 2 },
        { text: "Men an’anaviy usullarni afzal ko‘raman", score: 1 }
      ]
    },
    {
      id: 8,
      question: "Bolalar uchun darslarni qanchalik rejalashtirasiz?",
      options: [
        { text: "Darsga oldindan tayyorlanib, qiziqarli faoliyatlarni ham qo‘shaman", score: 3 },
        { text: "Asosan dars materialini ko‘rib chiqaman", score: 2 },
        { text: "O‘qitish jarayonida improvizatsiya qilaman", score: 1 }
      ]
    },
    {
      id: 9,
      question: "Bolalarning qiziqishini oshirish uchun qanday usullardan foydalanasiz?",
      options: [
        { text: "Interfaol o‘yinlar va ijodiy yondashuvlardan", score: 3 },
        { text: "An’anaviy dars usullaridan", score: 2 },
        { text: "Bolalar o‘zlari o‘rganishlari kerak, men faqat nazorat qilaman", score: 1 }
      ]
    },
    {
      id: 10,
      question: "Dars jarayonida texnologiyalardan foydalanasizmi?",
      options: [
        { text: "Ha, turli innovatsion vositalardan foydalanaman", score: 3 },
        { text: "Faqat zarur hollarda foydalanaman", score: 2 },
        { text: "Texnologiyalar bilan ishlashga qiziqmayman", score: 1 }
      ]
    },
    {
      id: 11,
      question: "Pedagogik jarayonda ijodkorlikka qanchalik e’tibor berasiz?",
      options: [
        { text: "Ijodiy yondashuvni yaxshi ko‘raman", score: 3 },
        { text: "Ba’zan e’tibor qarataman", score: 2 },
        { text: "Faqat dars o‘taman", score: 1 }
      ]
    },
    {
      id: 12,
      question: "Doimiy o‘rganish muhim deb bilasizmi?",
      options: [
        { text: "Ha, doimo yangi bilimlarni o‘rganishga harakat qilaman", score: 3 },
        { text: "Ba’zan yangi narsalarni o‘rganaman", score: 2 },
        { text: "Men allaqachon yetarlicha bilaman", score: 1 }
      ]
    },
    {
      id: 13,
      question: "Yaxshi tarbiyachining eng muhim fazilati qaysi?",
      options: [
        { text: "Mehribonlik va sabr-toqat", score: 3 },
        { text: "Tartib va intizom", score: 2 },
        { text: "Qattiqqo‘llik", score: 1 }
      ]
    },
    {
      id: 14,
      question: "Bolalar bilan ishlashda duch keladigan eng katta qiyinchilik nima deb o‘ylaysiz?",
      options: [
        { text: "Har bir muammoni o‘rganish va hal qilishga harakat qilaman", score: 3 },
        { text: "Tartibsizlik va shovqin meni qiynaydi", score: 2 },
        { text: "Bolalar bilan ishlash menga umuman yoqmaydi", score: 1 }
      ]
    },
    {
      id: 15,
      question: "Maktabgacha ta’limning eng asosiy maqsadi nima deb o‘ylaysiz?",
      options: [
        { text: "Bolalarni har tomonlama rivojlantirish", score: 3 },
        { text: "Intizom va tartibni o‘rgatish", score: 2 },
        { text: "Faqat boshlang‘ich bilim berish", score: 1 }
      ]
    }
  ]
};

export const reportQuestions = {
  first: [
    {
      id: 1,
      type: 'multiple_choice',
      quiz: 'Tarbiyachilar uchun transversal kompetentsiyalarni shakllantirish jarayonida integrativ metodlardan foydalanish qanchalik muhim? Quyidagi variantlardan eng to‘g‘ri va asosli javobni tanlang.',
      options: ["Tarbiyachilar bir necha fanlar bilan bog‘liq holatlarda muammolarni hal qilish ko‘nikmasiga ega bo‘lishlari uchun integrativ yondashuv shart.", "Har bir pedagog o‘z mutaxassisligi doirasida ishlashi kerak, shuning uchun integratsiya ortiqcha.", "Integrativ metodlar tarbiyachilar uchun unchalik muhim emas, chunki asosiy kompetentsiyalar pedagogikaga bog‘liq.", "Integrativ metodlar faqat yuqori ta’lim tizimida qo‘llaniladi, maktabgacha ta’limda ularga ehtiyoj yo‘q."],
      answer: "Tarbiyachilar bir necha fanlar bilan bog‘liq holatlarda muammolarni hal qilish ko‘nikmasiga ega bo‘lishlari uchun integrativ yondashuv shart.",
    },
    {
      id: 2,
      type: 'multiple_choice',
      quiz: 'Siz tajribali tarbiyachisiz. Guruhingizdagi bolalar yangi interaktiv dars metodikasiga qiyinchilik bilan moslashmoqda. Ba’zilari tez o‘zlashtirayotgan bo‘lsa, boshqalari ortda qolmoqda. Shuningdek, ota-onalarning ba’zilari ushbu yangi metodni yoqlamayapti.Siz qanday strategiyani tanlaysiz?',
      options: ["Ota-onalar bilan tushuntirish ishlari olib borish, bolalarning individual o‘ziga xos xususiyatlarini hisobga olgan holda metodikani moslashtirish.", "Faqatgina ota-onalarning fikrini inobatga olib, eski usulga qaytish.", "Faqat oldindan tuzilgan metodikaga tayanib, bolaning individual ehtiyojlarini hisobga olmaslik.", "Tez o‘zlashtirayotgan bolalarni oldinga chiqarib, ortda qolayotganlarga e’tibor bermaslik."],
      answer: "Ota-onalar bilan tushuntirish ishlari olib borish, bolalarning individual o‘ziga xos xususiyatlarini hisobga olgan holda metodikani moslashtirish.",
    },
    {
      id: 3,
      type: 'multiple_choice',
      quiz: 'Siz yangi tarbiyachi sifatida bolalar bilan mashg‘ulot o‘tkazyapsiz. Dastlabki kunlarda bolalar sizni diqqat bilan tinglashsa-da, keyinchalik ularning faolligi pasayib ketdi. Ba’zi bolalar e’tiborini yo‘qotyapti, ba’zilari esa faol ishtirok etmayapti. Sizning harakatlaringiz qanday bo‘ladi?',
      options: ["Mashg‘ulot uslublarini diversifikatsiya qilish, kinestetik, vizual va audial metodlardan foydalanish. Shuningdek, bolalarni faol jalb qilish uchun interaktiv metodlarni qo‘llash.", "Bolalarning qiziqishini oshirish uchun dars jarayoniga interaktiv o‘yinlar, jismoniy faollik mashqlari yoki musiqali elementlarni qo‘shaman. Bu orqali ularning e’tiborini jalb qilaman va faol ishtirokini rag‘batlantiraman.", "Faolligi pasaygan yoki ishtirok etmayotgan bolalarning sabablarini aniqlashga harakat qilaman. Ularning qiziqishlarini hisobga olib, individual yondashuv asosida ishtirok etishga undayman.", "Dars mazmunini bolalarning yosh xususiyatlariga mos ravishda soddalashtiraman va mavzularni ularning hayotiga yaqin misollar bilan tushuntiraman. Shuningdek, ularni ilhomlantiruvchi tarbiyaviy hikoyalar va lavhalardan foydalanaman."],
      answer: "Mashg‘ulot uslublarini diversifikatsiya qilish, kinestetik, vizual va audial metodlardan foydalanish. Shuningdek, bolalarni faol jalb qilish uchun interaktiv metodlarni qo‘llash.",
    },
    {
      id: 4,
      type: 'multiple_choice',
      quiz: 'Bir tarbiyachi innovatsion metodlardan foydalanishni xohlamaydi, chunki unga an’anaviy metodlar osonroq va tushunarliroq. Siz rahbar sifatida ushbu muammoni qanday hal qilasiz?',
      options: ["Pedagog bilan individual suhbat o‘tkazish, treninglar va tajriba almashish sessiyalarini tashkil qilish.", "Tarbiyachi bilan ochiq va samimiy suhbat o‘tkazaman. Innovatsion metodlarning bolalar rivojiga qanday ijobiy ta’sir ko‘rsatishini misollar orqali tushuntiraman va uni yangiliklarga qadam qo‘yishga ruhlantiraman.", "Innovatsion metodlarni o‘zlashtirishda unga amaliy yordam ko‘rsataman, treninglar tashkil qilaman yoki tajribali hamkasblar bilan hamkorlik qilish imkoniyatini yarataman.", "Yangi metodlarni birdaniga joriy qilish o‘rniga, asta-sekin, unga qulay bo‘lgan yo‘l bilan joriy etishni taklif qilaman. Shu orqali u bosqichma-bosqich innovatsion yondashuvga o‘rganib boradi."],
      answer: "Pedagog bilan individual suhbat o‘tkazish, treninglar va tajriba almashish sessiyalarini tashkil qilish.",
    },
    {
      id: 5,
      type: 'multiple_choice',
      quiz: 'Quyidagi usullardan qaysi biri ko‘proq interaktiv va transversal kompetentsiyalarni rivojlantirishga xizmat qiladi?',
      options: ["Lektsiyalar orqali bilim berish", "Rolli o‘yinlar va muammoli ta’lim", "Faqat yozma topshiriqlar berish", "O‘quvchilar faqat o‘z-o‘ziga baho qo‘yishi"],
      answer: "Rolli o‘yinlar va muammoli ta’lim",
    },
  ],
  second: [
    {
      id: 1,
      type: 'multiple_choice',
      quiz: 'Transversal kompetentsiyalarni rivojlantirish uchun eng samarali ta’lim yondashuvi qaysi?',
      options: ["Integrativ va tarmoqli yondashuv", "An’anaviy yondashuv", "Faoliyatga asoslangan yondashuv", "O‘qituvchi markazida bo‘lgan yondashuv"],
      answer: "Integrativ va tarmoqli yondashuv",
    },
    {
      id: 2,
      type: 'multiple_choice',
      quiz: 'Agar bolalar o‘quv materiallarini o‘zlashtirishda qiyinchiliklarga duch kelayotgan bo‘lsa, tarbiyachi qanday strategiyani tanlashi kerak?',
      options: ["Differensial yondashuv asosida har bir bolaning individual xususiyatlarini inobatga olish", "Barcha bolalarga bir xil yondashuvni qo‘llash", "Ota-onalar bilan aloqani to‘xtatish", "Bolalarni jazolash orqali motivatsiya berish"],
      answer: "Differensial yondashuv asosida har bir bolaning individual xususiyatlarini inobatga olish",
    },
    {
      id: 3,
      type: 'multiple_choice',
      quiz: 'Quyidagi pedagogik yondashuvlardan qaysi biri xatolik hisoblanadi?',
      options: ["Har bir bola uchun bir xil metodika tanlash", "O‘yin orqali o‘rgatish", "Muammoli ta’lim", "Differensial yondashuv"],
      answer: "Har bir bola uchun bir xil metodika tanlash",
    },
    {
      id: 4,
      type: 'multiple_choice',
      quiz: 'Bolalarning ijodiy fikrlash qobiliyatini rivojlantirish uchun qaysi metod eng mos?',
      options: ["Boshqotirmalar va muammoli vaziyatlarni hal qilish metodikasi", "Tayyor ma’lumotlarni takrorlash va yod olish", "An’anaviy dars uslublari", "Ota-onalar bilan aloqani to‘xtatish"],
      answer: "Boshqotirmalar va muammoli vaziyatlarni hal qilish metodikasi",
    }
  ],
  third: [
    {
      id: 1,
      type: 'multiple_choice',
      quiz: 'Tarbiyachilar uchun transversal kompetentsiyalarni shakllantirish jarayonida integrativ metodlardan foydalanish qanchalik muhim? Quyidagi variantlardan eng to‘g‘ri va asosli javobni tanlang.',
      options: ["Tarbiyachilar bir necha fanlar bilan bog‘liq holatlarda muammolarni hal qilish ko‘nikmasiga ega bo‘lishlari uchun integrativ yondashuv shart.", "Har bir pedagog o‘z mutaxassisligi doirasida ishlashi kerak, shuning uchun integratsiya ortiqcha.", "Integrativ metodlar tarbiyachilar uchun unchalik muhim emas, chunki asosiy kompetentsiyalar pedagogikaga bog‘liq.", "Integrativ metodlar faqat yuqori ta’lim tizimida qo‘llaniladi, maktabgacha ta’limda ularga ehtiyoj yo‘q."],
      answer: "Tarbiyachilar bir necha fanlar bilan bog‘liq holatlarda muammolarni hal qilish ko‘nikmasiga ega bo‘lishlari uchun integrativ yondashuv shart.",
    },
    {
      id: 2,
      type: 'multiple_choice',
      quiz: 'Siz tajribali tarbiyachisiz. Guruhingizdagi bolalar yangi interaktiv dars metodikasiga qiyinchilik bilan moslashmoqda. Ba’zilari tez o‘zlashtirayotgan bo‘lsa, boshqalari ortda qolmoqda. Shuningdek, ota-onalarning ba’zilari ushbu yangi metodni yoqlamayapti. Siz qanday strategiyani tanlaysiz?',
      options: ["Ota-onalar bilan tushuntirish ishlari olib borish, bolalarning individual o‘ziga xos xususiyatlarini hisobga olgan holda metodikani moslashtirish", "Faqatgina ota-onalarning fikrini inobatga olib, eski usulga qaytish", "Tez o‘zlashtirayotgan bolalarni oldinga chiqarib, ortda qolayotganlarga e’tibor bermaslik.", "Faqat oldindan tuzilgan metodikaga tayanib, bolaning individual ehtiyojlarini hisobga olmaslik."],
      answer: "Ota-onalar bilan tushuntirish ishlari olib borish, bolalarning individual o‘ziga xos xususiyatlarini hisobga olgan holda metodikani moslashtirish",
    },
    {
      id: 3,
      type: 'multiple_choice',
      quiz: 'Tarbiyachining innovatsion kompetentsiyalarini rivojlantirishda qanday usullar eng samarali hisoblanadi?',
      options: ["Faol o‘qitish metodlaridan foydalanish", "An’anaviy usullardan voz kechish", "Faqat bitta o‘quv qo‘llanmaga tayanish", "Shaxsiy tajribaga asoslangan holda metodlarni tanlash"],
      answer: "Faol o‘qitish metodlaridan foydalanish",
    },
    {
      id: 4,
      type: 'multiple_choice',
      quiz: 'Sizning guruhingizda bolalarning o‘quv motivatsiyasi pasaygan. Ularda yangi materiallarni o‘zlashtirish qiyinlashmoqda.',
      options: ["Darslarni qiziqarli o‘yinlar orqali tashkil qilish", "Faqat nazariy ma’lumot berish", "Jazo tizimini kuchaytirish", "Materiallarni tezroq o‘tib ketish"],
      answer: "Darslarni qiziqarli o‘yinlar orqali tashkil qilish",
    },
    {
      id: 5,
      type: 'multiple_choice',
      quiz: 'Tarbiyachi yangi metodikani sinovdan o‘tkazish jarayonida nimalarga e’tibor berishi kerak?',
      options: ["Bolalarning reaksiyasi va samaradorlik ko‘rsatkichlari", "Faqat o‘z tajribasiga tayanishi", "Metodikani birdaniga barcha guruhlarga joriy qilishi", "Faqatgina nazariy tahlil bilan cheklanishi"],
      answer: "Bolalarning reaksiyasi va samaradorlik ko‘rsatkichlari",
    }
  ]
}